module.exports = __webpack_public_path__ + "img/ministerio-iet-logo.4f02ea8e.jpg";